// extracted by mini-css-extract-plugin
export default {"text":"OutlineText_text__Gk6dO","face":"OutlineText_face__wvKAu"};